// Browser-side Sentry initialisation.
// Config comes from window.sentryConfig, injected by modules\Module\Module::init() via
// View::registerJsVar('sentryConfig', SentryHelper::getJsConfig()). Mirrors the PHP-side
// options in modules/Module/Helpers/SentryHelper.php so the two sides stay aligned.
import * as Sentry from '@sentry/browser';

// Known-noisy error patterns to drop before they reach Sentry. Ported from the retired
// strangeanimals/craft-3-sentry plugin's defaults. Substring match for strings, full
// match for RegExp.
const IGNORE_ERRORS = [
    // Random plugins / browser extensions
    'top.GLOBALS',
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy noise — see http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // Conduit toolbar JS injection
    'conduitPage',
    'chrome-extension',
    // DFlip library — silence while we update it
    "undefined is not an object (evaluating 'X.reset')",
    // Generic IE/Edge ID-mapping noise
    /Object Not Found Matching Id:\d+/,
];

// Origins to never accept events from (browser extensions, third-party SDKs that flake,
// localhost daemons running on user machines). Ported from the same plugin defaults.
const DENY_URLS = [
    // Facebook flakiness / blocked
    /graph\.facebook\.com/i,
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Browser extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Random localhost daemons / third-party scripts
    /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];

const config = window.sentryConfig || {};

if (config.enabled && config.dsn) {
    Sentry.init({
        dsn: config.dsn,
        environment: config.environment,
        release: config.release,
        tracesSampleRate: typeof config.tracesSampleRate === 'number' ? config.tracesSampleRate : 1.0,
        ignoreErrors: IGNORE_ERRORS,
        denyUrls: DENY_URLS,
        // Match the retired strangeanimals/craft-3-sentry plugin: attach cookies, IP,
        // and request headers to browser events. NB: privacy/GDPR consideration — confirm
        // this is acceptable for both artrage.com.au and rooftopmovies.com.au audiences
        // before keeping in production. The PHP SDK does NOT enable PII (matching the old
        // plugin's PHP-side default).
        sendDefaultPii: true,
    });
}
